<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper">
    <div class="container-fluid">
      <!-- sign up page start-->
      <div class="authentication-main">
        <div class="row">
          <div class="col-sm-12 p-0">
            <div class="auth-innerright">
              <div class="authentication-box">
                <div class="text-center">
                  <img
                    src="../assets/images/color_logo.png"
                    alt=""
                  >
                </div>
                <div class="card mt-4 p-4">
                  <h4 class="text-center">
                    {{ $t('passwordChange.ifrTyinat') }}
                  </h4>
                  <h6 class="text-center">
                    {{ $t('passwordChange.zhmtOlmasaIfrniziDaxilEdin') }}
                  </h6>
                  <form
                    class="theme-form"
                    @submit.prevent="updatePassword"
                  >
                    <div class="mb-3">
                      <label
                        for="oldPassword"
                        class="form-label"
                      >{{ $t('passwordChange.yeniIfr') }}</label>
                      <div class="input-group">
                        <input
                          id="oldPassword"
                          v-model="password"
                          :type="`${passwordVisible?'text': 'password'}`"
                          class="form-control"
                        >
                        <div class="input-group-append">
                          <button
                            type="button"
                            class="btn btn-light"
                            @click.prevent="passwordVisible=!passwordVisible"
                          >
                            <i :class="`${passwordVisible?'fa fa-eye-slash': 'fa fa-eye'}`" />
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="progress mb-3">
                      <div
                        class="progress-bar"
                        :class="`bg-${scorePassword.color}`"
                        :style="{width: `${scorePassword.percent}%`}"
                        role="progressbar"
                        aria-valuenow="0"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        {{ scorePassword.name }}
                      </div>
                    </div>

                    <div
                      v-if="scorePassword.percent>50"
                      class="form-group  mt-3 mb-0 text-center"
                    >
                      <button
                        class="btn btn-primary px-4"
                        type="submit"
                      >
                        {{ $t('passwordChange.ifrTsdiqEt') }}
                      </button>
                    </div>
                  </form>

                  <div class="text-center mt-4">
                    <a
                      class="btn-link text-capitalize"
                      href="#"
                      @click.prevent="logout"
                    >{{ $t('passwordChange.x') }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- sign up page ends-->
    </div>
  </div>
  <!-- page-wrapper Ends-->
</template>

<script>
import {
  userSetPassword
} from "@/repositories/GeneralDataRepository";
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";

export default {
  name: 'SignUp',

  data() {
    return {
      mediaBase: mediaBase,
      password: '',
      passwordVisible: false,
    }
  },

  computed: {
    ...mapState({
      token: state => state.auth.token,
    }),


    scorePassword() {
      let score = 0;
      if (!this.password)
        return score;

      // award every unique letter until 5 repetitions
      let letters = {};
      for (const element of this.password) {
        letters[element] = (letters[element] || 0) + 1;
        score += 5.0 / letters[element];
      }

      // bonus points for mixing it up
      let variations = {
        digits: /\d/.test(this.password),
        lower: /[a-z]/.test(this.password),
        upper: /[A-Z]/.test(this.password),
        nonWords: /\W/.test(this.password),
      }

      let variationCount = 0;
      for (let check in variations) {
        variationCount += (variations[check] === true) ? 1 : 0;
      }
      score += (variationCount - 1) * 10;

      score=  parseInt((score/20)+"");

      switch (score) {
        case 0:
          return {name: this.$t("passwordChange.risk"), percent: 10, score: score, color: 'danger'};
        case 1:
          return  {name: this.$t("passwordChange.texmin"), percent: 30, score: score, color: 'danger'}
        case 2:
          return  {name: this.$t("passwordChange.zeif"), percent: 50, score: score, color: 'warning'}
        case 3:
          return  {name: this.$t("passwordChange.guclu"), percent: 70, score: score, color: 'primary'}
        case 4:
          return  {name: this.$t("passwordChange.secure"), percent: 100, score: score, color: 'success'}
        default:
          return {name: this.$t("passwordChange.namelum"), percent: 0, score: score, color: 'dark'}
      }
    },
  },
  mounted() {

  },

  methods: {

    updatePassword() {
      if( this.scorePassword.percent<50) {
        this.$swal({
          title: `Xəta !`,
          text: this.$t("passwordChange.message"),
          icon: 'error',
        })
        return;
      }

      userSetPassword(this.token, this.password).then(({code, message}) => {

        if (code === 200) {
          this.$swal({
            title: this.$t("congratulations"),
            text: this.$t("passwordChange.successMessage"),
            icon: 'success',
          }).then(() => {
            this.$router.push({name: 'welcome'});
          })
        } else if (code === 401 || code === 404) {
          this.$swal({
            title: `Xəta !`,
            text: this.$t("passwordChange.errorMessage"),
            icon: 'error',
          })
        } else {
          this.$swal({
            title: `Error ${code} !`,
            text: message,
            icon: 'error',
          })
        }

      });


    },
    logout() {
      localStorage.removeItem('token');
      this.$router.push({name: 'login'});
    }
  }
}
</script>
